import Color from '@constants/Color'
import axios from 'axios'
import { CLASSES_SIMULADOR } from '@constants/Text'

/**
 * Indica a cor da classe do ativo para gráficos.
 * @param {String} color Classe do ativo.
 * @returns {String} Hexadecimal - Retorna o valor da cor da classe.
 */
export const getClassColor = (color) =>
  Color['grafico'][color || 'Outros'] || Color['light_mode'].purple

export const toDefaultClass = (classe, return_old = true) => {
  const old = classe
  classe = (classe || '').toLowerCase()

  if (classe.includes('pós')) {
    return 'RF Pós-Fixado'
  }

  if (classe.includes('pré')) {
    return 'RF Pré-Fixado'
  }

  if (classe.includes('infl')) {
    return 'RF Inflação'
  }

  if (
    classe.includes('ações') ||
    classe.includes('ação') ||
    classe === 'renda variavel'
  ) {
    return 'Renda Variável'
  }

  if (classe.includes('fii') || classe.includes('imobili')) {
    return 'Fundo Imobiliário'
  }

  if (classe.includes('multim')) {
    return 'Multimercado'
  }

  if (classe.includes('prev')) {
    return 'Fundo de Previdência'
  }

  if (classe.includes('saldo em conta')) {
    // return 'Caixa'
    return 'Saldo em Conta'
  }

  return return_old || CLASSES_SIMULADOR.includes(old) ? old : null
}

/**
 * Recebe duas versões e retorna 1 se a primeira for maior, 2 se a segunda for e 0 se forem iguais.
 * @param {String} v1 MAJOR.MINOR.PATCH
 * @param {String} v2 MAJOR.MINOR.PATCH
 */
export const compareVersions = (v1, v2) => {
  if (v1 === v2) {
    return 0
  }

  return v1 > v2 ? 1 : 2
}

/**
 * Coleta o DDD do número de telefone.
 * @param {String} phone Telefone (99) 99999-9999.
 * @returns {Number} DDD - Código de área do telefone. Número entre parênteses.
 */
export const getAreaCode = (phone) => {
  try {
    return phone.match(/^.*?\([^\d]*(\d+)[^\d]*\).*$/)[1]
  } catch (e) {
    console.log(e)
  }
  return phone
}

/**
 * Remove o código de área para coletar somente o número do telefone.
 * @param {String} phone Telefone (99) 99999-9999.
 * @returns {String} Telefone - retorna somente o número do telefone. O que está fora dos parênteses.
 */
export const getPhoneNumber = (phone) => {
  try {
    const area = phone.match(/^.*?\([^\d]*(\d+)[^\d]*\).*$/)[1]
    return phone
      .replace(`(${area})`, '')
      .replace('-', '')
      .trim()
  } catch (e) {
    console.log(e)
  }
  return phone
}

/**
 * Coletar dados de endereço de acordo com CEP pela API da pagar.me.
 * @param {String} cep CEP, formatado ou somente números.
 * @return {Object} Endereço - Objeto com os dados do endereço.
 *      Exemplo de sucesso:
 *          {"zipcode":"88070740","street":"Avenida Santa Catarina","neighborhood":"Canto","city":"Florianópolis","state":"SC"}
 */
export const getCep = async (cep) => {
  if (cep.length === 9) {
    cep = cep.replace('-', '')

    const api = axios.create({
      baseURL: 'https://api.pagar.me/1/zipcodes/',
    })

    let res = await api
      .get(cep)
      .then((r) => JSON.stringify(r))
      .catch((error) => JSON.stringify(error))

    res = JSON.parse(res)

    return res
  }
  return false
}
